<template>
  <v-card
    id="history-tabs"
    class="main__light_green height-100">
    <v-card-text
      v-if="user"
      class="pb-2 px-2"
      :class="($_tabs.length && $_tabs[tennderInfoTab] && $_tabs[tennderInfoTab].value == 'chat') ? 'commented': 'not_commented'">
      <div class="flex flex-between">
        <v-tabs
          v-model="tennderInfoTab"
          background-color="main__light_green"
          centered
          class="history-tabs tabs pb-1"
          :class="{'hide-slider': !$_tabs || $_tabs.length < 2}"
          color="var(--black-color)"
          :show-arrows="!!$_tabs && $_tabs.length > 2">
          <v-tab
            v-for="(tabItem, n) in $_tabs"
            :key="tabItem.name"
            class="px-0 h4-headline black--text tab-name px-2"
            :class="{'pr-4': tabItem.badge.dot && tabItem.count, 'ml-2': n===0}"
            :data-qa="`tab-${n}`">
            <sBadge
              :class="!tabItem.badge.dot && tabItem.count ? 'mr-3' : ''"
              :color="tabItem.badge.dot ? 'red' : 'transparent'"
              :content="tabItem.count || 0"
              data-qa="history-tabs-badge"
              :dot="tabItem.badge.dot"
              :offset-x="tabItem.badge.dot ? 1 : 5"
              :offset-y="tabItem.badge.dot ? 4 : 10"
              overlap
              :text-color="tabItem.badge.dot ? 'var(--white-color)' : 'var(--black-color)'"
              :value="tabItem.count || 0">
              <sIcon
                v-if="tabItem.value==='innerChat' && (!currentSubscription || currentSubscription.muted)"
                size="12"
                type="no-notifications"/>
              {{ tabItem.name }}
            </sBadge>
          </v-tab>
        </v-tabs>
        <div
          v-if="$_tabs[tennderInfoTab]"
          class="history-dialog">
          <HistoryDialog
            :current-tab.sync="tennderInfoTab"
            :disabled="!$_tabs[tennderInfoTab].showDialog"
            :item-id.sync="historyDialogProps.itemId"
            :open.sync="historyDialogProps.open"
            :tabs="$_tabs"
            :tender="item"
            @loadPage="$_getInnerChat(subscribleEntity)"
            @update-items="val => $set(this, val.prop, val.val)"/>
        </div>
      </div>
      <v-tabs-items
        v-if="$_tabs.length"
        ref="tabs"
        v-model="tennderInfoTab"
        class="main__light_green height-100"
        style="overflow: auto; max-height: calc(100% - 40px);">
        <v-tab-item
          class="height-100"
          data-qa="chat">
          <HistoryInnerChat
            :item="item"
            :loading="loading"
            :value.sync="innerChat"
            @loadPage="$_getInnerChat(subscribleEntity)"/>
        </v-tab-item>
        <v-tab-item
          class="height-100"
          data-qa="comments">
          <CommentHistory
            :items="comments"
            :loading="loading"
            @openChat="val => {historyDialogProps.itemId = val; historyDialogProps.open = true}"/>
        </v-tab-item>
        <v-tab-item
          v-if="$can('set', 'privateMessageToBidder')"
          class="height-100"
          data-qa="questions">
          <QuestionsHistory
            :items="questions"
            :loading="loading"
            @openChat="val => {historyDialogProps.itemId = val; historyDialogProps.open = true}"/>
        </v-tab-item>
        <v-tab-item
          class="height-100"
          data-qa="history">
          <EventHistory
            :items="history"
            :loading="loading"
            :spr="sprHistory"/>
        </v-tab-item>
        <v-tab-item
          class="height-100"
          data-qa="agreement">
          <AgreementsHistory
            :items="agreements"
            :loading="loading"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import HistoryDialog from 'components/common/dialogs/HistoryDialog.vue'
import EventHistory from 'components/common/blocks/history/EventHistory.vue'
import AgreementsHistory from 'components/agreement/AgreementsHistory.vue'
import CommentHistory from 'components/common/blocks/comments/CommentHistory.vue'
import QuestionsHistory from 'components/common/blocks/questions/QuestionsHistory.vue'
import HistoryInnerChat from 'components/common/blocks/inner-chat/HistoryInnerChat.vue'

import { functionRandom } from 'mixins'
import tenderInfoPanelMixin from 'mixins/tenderInfoPanelMixin.js'
import innerChatMixin from 'mixins/innerChatMixin.js'


import { mapGetters } from 'vuex'

export default {
  name: 'historyTabs',
  mixins: [ functionRandom, tenderInfoPanelMixin, innerChatMixin ],
  data() {
    return {
      chatST: {},
    }
  },
  props: {
    item: Object,
    type: String,
    oneMode: {    /*Только одна конкретная вкладка*/
      type: String,
      validator: function (value) {
        return ['innerChat', 'comments', 'questions', 'approval', 'lot'].indexOf(value) !== -1
      }
    }
  },
  computed: {
    ...mapGetters({
      settings: 'getSettings',
      user: 'GET_USER'
    }),
    messages() {
      return this.chatST?.messages
    },
    chatkeyAndType() {
      let key = null
      let type = null
      if (this.type == 'TENDER') {
        key = this.item.tenderId
        type = 1
      } else if (this.type == 'LOT') {
        key = this.item.itemId
        type = 2
      } else {
        key = this.item.id
        type = 3
      }

      return {key, type}
    },
    show_all_questions() {
      let has_answer = (this.comments.some(comm => comm.answer) && this.comments?.length > 1 )
      let have_no_answer =  (this.comments.some(comm => !comm.answer) && has_answer )
      return have_no_answer || has_answer
    },
  },
  methods: {
    /**
     * Для обновление истории очищаем данные и уходим на первую вкладку
     */
    updateHistory() {
      this.comments = []
      this.history = []
      this.agreements = []
      if (this.tennderInfoTab === 0) {
        this.$_getTenderComment()
      } else {
        this.tennderInfoTab = 0
      }
    },
    sliceQuestions(item, n, all) {
      let has_no_answer = !item.answer
      if (!all.some(comm => !comm.answer) ) {
        return n == 0
      }
      return has_no_answer
    },
    setHeight() {
      let height = this.$el.previousElementSibling?.clientHeight || 0,
        next = this.$el.nextElementSibling?.clientHeight || 0

      this.$el.style.height = `calc(100% - ${height + next}px)`
    },
    closeModal() {
      this.historyDialogProps.open = false
    }
  },
  watch: {
    tennderInfoTab: {
      immediate: true,
      deep: true,
      handler(val) {
        if (this.$_tabs[val]?.value == 'comments' && !this.comments.length) {
          this.$_getTenderComment()
        } else  if (this.$_tabs[val]?.value == 'agreement' && !this.agreements.length) {
          this.$_getAgreementsHistory()
        } else if (this.$_tabs[val]?.value == 'history' && !this.history.length) {
          this.$_getTenderHistory()
        } else if (this.$_tabs[val]?.value == 'questions' && this.$can('set', 'privateMessageToBidder')) {
          this.$_getTenderQuestions()
        } else if (this.$_tabs[val]?.value == 'innerChat') {
          this.$_getInnerChat(this.subscribleEntity, true)
        }
        this.$_savePropToLocalStorage(this.localKey, {dialog: this.historyDialogProps, tab: val || 0 }, true)
      }
    },
    item() {
      this.tennderInfoTab = 0
    },
  },
  async created() {
    this.$root.$on('updateHistory', this.updateHistory)
    this.$root.$on('clickTagItem', this.closeModal)
  },
  async beforeDestroy() {
    this.$root.$off('updateHistory', this.updateHistory)
    this.$root.$on('clickTagItem', this.closeModal)
  },
  components: {
    EventHistory,
    HistoryDialog,
    CommentHistory,
    QuestionsHistory,
    HistoryInnerChat,
    AgreementsHistory
  }
}
</script>
<style lang="scss">
.history-tabs {
  width: calc(100% - 30px);
}
#history-tabs {
  transition: all 0.2s;
  .h7-text {
    text-align: start;
  }
  .commented {
    height: calc(100% - 140px);
  }
  .not_commented {
    height: 100% ;
  }
  .hide-slider {
    .v-tabs-slider-wrapper {
      display: none;
    }
  }
  .v-slide-group__next, .v-slide-group__prev {
    &:not(&--disabled) {
      max-width: 18px;
      min-width: 18px;
      width: 18px;
    }
  }
}
</style>
